import { useEffect, useState } from "react";

export const BASE = `${process.env.PUBLIC_URL || ""}/hero`;
// Bump when the film files are replaced so browsers don't keep the old cut.
export const V = "v=3";
export const MEDIA = {
  wide: { video: `${BASE}/sab-pour-1080`, poster: `${BASE}/sab-pour-first.jpg?${V}` },
  portrait: { video: `${BASE}/sab-pour-portrait`, poster: `${BASE}/sab-pour-first-portrait.jpg?${V}` },
};
// H.264 for Safari/Chrome/Edge; VP9 WebM only for browsers without H.264.
const videoExt = () => (document.createElement("video").canPlayType('video/mp4; codecs="avc1.640028"') ? "mp4" : "webm");
export const videoUrl = (media) => `${media.video}.${videoExt()}?${V}`;

const PORTRAIT_QUERY = "(max-aspect-ratio: 1/1)";

export const useVariant = () => {
  const [variant, setVariant] = useState(() => (window.matchMedia(PORTRAIT_QUERY).matches ? "portrait" : "wide"));
  useEffect(() => {
    const mq = window.matchMedia(PORTRAIT_QUERY);
    const on = () => setVariant(mq.matches ? "portrait" : "wide");
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, []);
  return variant;
};

// Waits for the page's own load (so the film never competes with first paint), a short timeout, or the first scroll/touch.
const afterLoad = (cb) => {
  let done = false;
  let timer = 0;
  const go = () => {
    if (done) return;
    done = true;
    cleanup();
    cb();
  };
  const events = ["scroll", "wheel", "pointerdown", "keydown", "touchstart"];
  const cleanup = () => {
    clearTimeout(timer);
    window.removeEventListener("load", go);
    events.forEach((e) => window.removeEventListener(e, go));
  };
  if (document.readyState === "complete") {
    timer = setTimeout(go, 0);
  } else {
    window.addEventListener("load", go);
    timer = setTimeout(go, 1200);
  }
  events.forEach((e) => window.addEventListener(e, go, { passive: true, once: true }));
  return cleanup;
};

// Film source for the <video>, handed over once the page has painted. The browser streams and caches it
// (one download), so scrubbing starts as soon as the first part arrives.
export const useDeferredSource = (url) => {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let live = true;
    const cancel = afterLoad(() => live && setSrc(url));
    return () => {
      live = false;
      cancel();
    };
  }, [url]);
  return src;
};
